import axiosInstance from '../helpers/interceptor';
import { userHotelDetails } from '../helpers/handleBrandAndHotelData';

export const getUsers = async (userName: string) => {
  const { selectedHotel } = userHotelDetails();
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/customerClientUser/assignees/?page=1&pageSize=100&isActive=true&sort=userLastName%2CuserFirstName&name=${userName}&&selectedHotelId=${selectedHotel}`
  );
  return data;
};
